{
  "canonicalOrigin": "https://belgium-in-maps.be",
  "aliasOrigins": [
    "https://www.belgium-in-maps.be",
    "https://belgiuminmaps.be",
    "https://www.belgiuminmaps.be"
  ],
  "brandName": "Belgium in Maps",
  "publicIdentity": {
    "schemaType": "Organization",
    "name": "Belgium in Maps",
    "url": "https://belgium-in-maps.be/"
  },
  "parentProduct": {
    "name": "Horizon Mapper",
    "url": "https://horizonmapper.com/"
  },
  "contactEmail": "hello@horizonmapper.com",
  "apiOrigin": "https://api.belgium-in-maps.be",
  "dataOrigin": "https://data.belgium-in-maps.be",
  "dataReleasePrefix": "releases/belgium-map-25e433d5fa03-b8272812d94d",
  "dataRemotePrefixes": [
    "data/geometry/",
    "data/values/",
    "data/cubes/",
    "data/packs/",
    "data/qa/",
    "data/manifests/",
    "data/locales/"
  ],
  "clarityProjectId": "y15ozd66in",
  "ga4MeasurementId": "G-4RM23X2LW8",
  "cloudflareWebAnalyticsToken": "1e3991dca4df46169a8fffed6af8ec87",
  "turnstileSiteKey": "0x4AAAAAAEN3m_AUI5jwFQjm",
  "audienceEnabled": true
}
